import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import media from '../../../services/generateMediaQueries'
// import Background from '../../../assets/img/wifi-header.webp'
import Background from '../../../assets/img/ZingBadgePlusModal.webp'
import Icon from '../../ui/Icon/Icon'
import { loungeFormat } from '../../../services/data/dateFormat'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);
  &:focus {
    outline: 0;
    border: 0px;
  }

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  width: 380px;
  min-height: 600px;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  position: relative;
  margin: 3rem auto;
  border-radius: 8px;
  overflow: hidden;
  /* background: #ffffff; */
  background: url(${Background});
  background-size: cover;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Content = styled.div`
  min-height: 600px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  padding: 3rem;
`

const Title = styled.h3`
  color: var(--color-bg-form);
  font-size: 1rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin: 2rem 0 0 0;
  position: relative;
  z-index: 1;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 2rem 0;
  padding: 0 1.6875rem;
  text-align: center;
  color: var(--color-bg-form);
`

const overlay = {
  zIndex: 10041,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {
  width: '380px',
  minHeight: '600px',
  margin: 'auto',
  border: '0px',
}

const DateTime = styled.h2`
  color: white;
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  opacity: 0.5;
  margin: 0;
  position: relative;
  z-index: 1;
`

function ZingBadgeModal(props) {
  const {
    show,
    onClose,
    zIndex,
    shouldCloseOnOverlayClick = true,
    // description,
  } = props

  const [dateNow, setDateNow] = React.useState(new Date())

  const tick = () => {
    setDateNow(new Date())
  }

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000)

    return () => {
      clearInterval(timerID)
    }
  })

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      // bodyOpenClassName="sticky-modal-open"
      // htmlOpenClassName="sticky-modal-open"
      // {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            {/* <Header src={Background} alt="Be Right Back" /> */}
            <Title>
              Look out for more exciting offers and benefits as a Zing Plus
              member!
            </Title>
            <Description>
              Keep using your linked GCash at participating merchants to
              continue earning Zing Points.
            </Description>
            <DateTime>{loungeFormat(dateNow)}</DateTime>
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

ZingBadgeModal.defaultProps = {
  // TODO: specify default props
}

ZingBadgeModal.propTypes = {
  // TODO: specify prop types
}

export default ZingBadgeModal
